module.exports = __webpack_public_path__ + "img/hvac.58e36784.svg";